import * as React from 'react'
import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./PlaygroundPage')

export const PlaygroundPage = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => <Module.default {...props} />
})



// WEBPACK FOOTER //
// ./src/routes/PlaygroundPage/index.js